import { useTranslation } from "react-i18next";

import "./index.css";

const SrpTitleGuide = () => {
  const { t } = useTranslation("components/intro");

  return (
    <div className="container">
      <span className="text">{t("topTitle")}</span>
    </div>
  );
};

export default SrpTitleGuide;
